import { createContext, useContext } from 'react';

/**
 * Lugar en la barra superior donde cada sección pone sus pestañas (SubNav). Así cada sección
 * se ve como una app propia, sin el menú de todas las demás.
 */
export const ProductNavSlot = createContext<HTMLElement | null>(null);

export function useProductNavSlot() {
  return useContext(ProductNavSlot);
}
